const env = {
  server: {
    url: process.env.REACT_APP_API_URL,
  },
  node_env: process.env.REACT_APP_NODE_ENV,
};

export default env;
